module.exports = __webpack_public_path__ + "img/homepage.437df0eb.png";